/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styles from './FloCheckbox.module.css';
import classnames from 'classnames';
import { FloComponentProps } from 'components';

interface FloCheckboxProps extends FloComponentProps  {
  checked?: boolean;
  onChange: () => void;
  mixed?: boolean;
  noMargin?: boolean;
}

export const FloCheckbox: React.FC<FloCheckboxProps> = ({checked, onChange, mixed, className, noMargin}) => {
  return (
    <>
      { mixed ?
        <svg
          className={classnames(
            styles.checkbox,
            className,
            { [styles.removeMargin]: noMargin }
          )}
          onClick={onChange}
          width="20" height="20" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="21" height="22" rx="4.5" fill="#F2F5F8" stroke="#D3DAE0"/>
          <line x1="7" y1="12" x2="15" y2="12" stroke="#1B355E" stroke-width="2" stroke-linecap="round"/>
        </svg>
      : checked ?
        <svg
          className={classnames(
            styles.checkbox,
            className,
            { [styles.removeMargin]: noMargin }
          )}
          onClick={onChange}
          width="20" height="20" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="22.6364" height="22.6364" rx="5" fill="#1B355E"/>
          <path d="M8.3904 17.3846C8.72481 17.7762 9.1652 17.9824 9.64138 17.9824C10.1169 17.9824 10.5572 17.7552 10.8924 17.3846L18.485 8.49422C19.1717 7.69012 19.1717 6.39054 18.485 5.58549C17.7982 4.7814 16.6884 4.7814 16.0008 5.58549L9.62352 13.011L6.99917 9.93807C6.31245 9.13397 5.20257 9.13397 4.51504 9.93807C3.82832 10.7422 3.82832 12.0417 4.51504 12.8468L8.3904 17.3846Z" fill="white"/>
        </svg>
      :
        <svg
          className = {classnames(
            styles.checkbox,
            className,
            { [styles.removeMargin]: noMargin }
          )}
          onClick={onChange}
          width="20" height="20" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="21.6364" height="21.6364" rx="4.5" fill="white" stroke="#B4BDC5"/>
        </svg>
      }
    </>
  )
}